module.exports = __webpack_public_path__ + "static/img/construction.6ea684a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction.jpg
// module id = tWKH
// module chunks = 0